import type { MenuItem } from '@/types';

/**
 * Getting Started docs menu
 */
export const gettingStartedMenu: MenuItem[] = [
  {
    label: 'Basic Demo',
    path: '/getting-started/basic-demo',
  },
  {
    label: 'Advanced Demo',
    path: '/getting-started/advanced-demo',
  },
  {
    label: 'Create a Channel or Room Using the portal',
    path: '/getting-started/create-a-channel-or-room-using-the-phenix-portal',
  },
  {
    label: 'Create EdgeAuth Tokens in the Portal',
    path: '/getting-started/creating-edgeauth-tokens-in-the-portal',
  },
  {
    label: 'Ingest Options',
    path: '/getting-started/ingest-options',
  },
  {
    label: 'Workflow',
    path: '/getting-started/workflow',
  },
  {
    label: 'Getting Started with WebSDK 2.0',
    path: '/getting-started/getting-started-with-websdk-2',
  },
  {
    label: 'WebSDK 2.0 Logging and Error Handling',
    path: '/getting-started/websdk-2-logging-and-error-handling',
  },
  {
    label: 'Mobile App Demos',
    path: '/getting-started/mobile-app-demos',
  },
  {
    label: 'Training Videos',
    path: '/getting-started/training-videos',
  },
];
